import { parseAsStringEnum } from 'nuqs';

export const DocumentType = {
  Receipt: 'RECEIPT',
  DeliveryNote: 'DELIVERY_NOTE',
  DonationAgreement: 'DONATION_AGREEMENT',
  SwornStatement: 'SWORN_STATEMENT',
  AssociationRegistration: 'ASSOCIATION_REGISTRATION',
  FoodAidHabilitation: 'FOOD_AID_HABILITATION',
  FoodEstablishmentDeclaration: 'FOOD_ESTABLISHMENT_DECLARATION',
  FoodSafetyManagementPlan: 'FOOD_SAFETY_MANAGEMENT_PLAN',
  FoodSafetyTrainingCertificate: 'FOOD_SAFETY_TRAINING_CERTIFICATE',
  LiabilityInsurance: 'LIABILITY_INSURANCE',
} as const;

export type DocumentTypeValue = (typeof DocumentType)[keyof typeof DocumentType];

export const ALL_DOCUMENT_TYPES = Object.values(DocumentType);
export const UPLOADABLE_DOCUMENT_TYPES: DocumentTypeValue[] = ALL_DOCUMENT_TYPES.filter(
  (type) => type !== DocumentType.DeliveryNote,
);

export const DOCUMENT_TYPES_WITH_STORE: DocumentTypeValue[] = [
  DocumentType.Receipt,
  DocumentType.DonationAgreement,
];
export const DOCUMENT_TYPES_WITH_PERIOD: DocumentTypeValue[] = [DocumentType.Receipt];
export const DOCUMENT_TYPES_WITH_VALIDITY: DocumentTypeValue[] = [DocumentType.LiabilityInsurance];

export type UploadSource = 'user' | 'system';

export type DocumentDates = {
  period?: string | null;
  periodFrom?: string | null;
  periodTo?: string | null;
  validFrom?: string | null;
  validTo?: string | null;
};

export type CharityDocument = {
  id: string;
  name: string;
  chainName: string | null;
  storeNames: string[];
  type: DocumentTypeValue;
  uploadedAt: string;
  uploadedBy: UploadSource;
  uploadedByName: string | null;
  period: string | null;
  dates: DocumentDates | null;
  storeId: string | null;
  isEditable: boolean;
  isDeletable: boolean;
};

export const isDocumentType = (value: unknown): value is DocumentTypeValue =>
  ALL_DOCUMENT_TYPES.some((type) => type === value);

export type DocumentFormValues = {
  name: string;
  documentType: DocumentTypeValue | null;
  storeId?: string | null;
  validFrom?: string;
  validTo?: string;
  periodFrom?: Date | null;
  periodTo?: Date | null;
  changeNote?: string;
};

export const DocumentsTab = {
  Categorized: 'categorized',
  All: 'all',
} as const;

type DocumentsTabValue = (typeof DocumentsTab)[keyof typeof DocumentsTab];

export const DOCUMENTS_TAB_QUERY_PARAM = 'tab';

export const documentsTabParser = parseAsStringEnum<DocumentsTabValue>(Object.values(DocumentsTab))
  .withDefault(DocumentsTab.Categorized)
  .withOptions({ clearOnDefault: true, history: 'replace' });

export const isDocumentsTab = (value: unknown): value is DocumentsTabValue =>
  Object.values(DocumentsTab).some((tab) => tab === value);
